import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientsPage from 'model/PatientsPage'
import { searchPatientByNameSelectors } from '../../../src/patients/util/patient-name-util'

export class PatientsPagesRepository extends WebRepository<PatientsPage> {
  constructor() {
    super(new Api('patients'))
  }

  async searchPatientsPage(bookmark: string, selector?: any, sort?: any): Promise<PatientsPage> {
    return super.searchPage({
      limit: 10,
      bookmark: bookmark,
      selector: selector || {},
      sort: sort || {},
    })
  }

  async searchPatientsPageText(
    bookmark: string,
    text: string,
    selector?: any,
    sort?: any,
  ): Promise<PatientsPage> {
    return super.searchPage({
      selector: {
        $or: searchPatientByNameSelectors(text),
        $and: [selector || {}],
      },
      limit: 10,
      bookmark: bookmark,
      sort: sort || {},
    })
  }

  async searchPatientsSinglePageText(
    text: string,
    selector?: any,
    sort?: any,
  ): Promise<PatientsPage> {
    return super.searchPage({
      selector: {
        $or: searchPatientByNameSelectors(text),
        $and: [selector || {}],
      },
      limit: 200,
      bookmark: '',
      sort: sort || {},
    })
  }

  async searchPatientsPageInGroup(groupId: string, bookmark: string): Promise<PatientsPage> {
    return super.searchPage({
      groupId,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchPatientsPageInGroupText(
    groupId: string,
    bookmark: string,
    text: string,
  ): Promise<PatientsPage> {
    return super.searchPage({
      groupId,
      selector: {
        $or: searchPatientByNameSelectors(text),
      },
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchPatientsPageInMainGroup(bookmark: string): Promise<PatientsPage> {
    return super.searchPage({
      mainGroup: true,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchPatientsPageInMainGroupText(bookmark: string, text: string): Promise<PatientsPage> {
    return super.searchPage({
      mainGroup: true,
      selector: {
        $or: searchPatientByNameSelectors(text),
      },
      limit: 10,
      bookmark: bookmark,
    })
  }
}

export default new PatientsPagesRepository()
